import React from 'react';

const FacebookSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.748 8.92433V7.34543C11.748 6.7533 12.1471 6.61405 12.4306 6.61405H14.1604V4.00986L11.7769 4C9.13143 4 8.53012 5.94429 8.53012 7.18584V8.92156H7V11.6049H8.53012V19.2H11.748V11.6049H13.919L14.2 8.92433H11.748Z"
      className="socialIcons-SVG"
    />
  </svg>
);

const TwitterSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.792 7.66341C17.792 11.9996 14.3946 17 8.1793 17C6.27109 17 4.49529 16.4591 3 15.5251C3.26545 15.5559 3.53366 15.5723 3.80556 15.5723C5.39026 15.5723 6.8453 15.0481 8.00264 14.1673C6.52456 14.1392 5.27781 13.1915 4.84769 11.8868C5.05261 11.9262 5.26306 11.9456 5.48243 11.9456C5.78843 11.9456 6.08859 11.9068 6.37155 11.8307C4.8271 11.5307 3.66085 10.2045 3.66085 8.61412C3.66085 8.59979 3.66085 8.58606 3.66393 8.57173C4.11679 8.81858 4.64 8.96455 5.19424 8.98097C4.28761 8.39502 3.68973 7.3885 3.68973 6.24975C3.68973 5.64918 3.85748 5.08562 4.14628 4.60027C5.81147 6.58645 8.30342 7.89325 11.1091 8.03026C11.0513 7.78908 11.0224 7.53984 11.0224 7.28134C11.0224 5.46978 12.5352 4 14.4007 4C15.3731 4 16.2506 4.39849 16.8653 5.03458C17.6362 4.88891 18.3612 4.61669 19.0138 4.2385C18.7594 5.00682 18.2251 5.64918 17.5268 6.05573C18.211 5.97752 18.8636 5.80081 19.4667 5.54023C19.0166 6.19632 18.4417 6.7736 17.784 7.23687C17.7892 7.37686 17.792 7.51984 17.792 7.66341Z"
      fill="#3E4968"
      className="socialIcons-SVG"
    />
  </svg>
);
const LinkedinSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.95697 3H17.2432C17.9926 3 18.6001 3.648 18.6001 4.44733V17.5526C18.6001 18.352 17.9926 19 17.2432 19H4.95697C4.2076 19 3.6001 18.352 3.6001 17.5526V4.44733C3.6001 3.648 4.2076 3 4.95697 3ZM7.84686 17.2366C8.06495 17.2366 8.24173 17.0481 8.24173 16.8155V9.2996C8.24173 9.06697 8.06495 8.87841 7.84686 8.87841H6.166C5.94791 8.87841 5.77113 9.06697 5.77113 9.2996V16.8155C5.77113 17.0481 5.94791 17.2366 6.166 17.2366H7.84686ZM7.00643 8.16993C6.12453 8.16993 5.4096 7.40733 5.4096 6.46664C5.4096 5.52595 6.12453 4.76335 7.00643 4.76335C7.88833 4.76335 8.60327 5.52595 8.60327 6.46664C8.60327 7.40733 7.88837 8.16993 7.00643 8.16993ZM16.6628 17.2366C16.8633 17.2366 17.0259 17.0632 17.0259 16.8494V13.2119L17.0259 13.185C17.026 11.5981 17.0261 8.75229 14.1542 8.75229C12.85 8.75229 12.2374 9.26157 11.8252 9.92138V9.26568C11.8252 9.05181 11.6627 8.87841 11.4622 8.87841H9.7177C9.5172 8.87841 9.35464 9.05181 9.35464 9.26568V16.8494C9.35464 17.0632 9.5172 17.2366 9.7177 17.2366H11.4622C11.6627 17.2366 11.8252 17.0632 11.8252 16.8494V12.7832C11.8705 12.2369 12.096 11.0195 13.2076 11.0195C14.5351 11.0195 14.5088 12.5457 14.4977 13.1886C14.4969 13.2397 14.4961 13.2853 14.4961 13.324V16.8494C14.4961 17.0632 14.6586 17.2366 14.8591 17.2366H16.6628Z"
      className="socialIcons-SVG"
    />
  </svg>
);

const YoutubeSVG = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6201 4C18.1656 4 19.4985 4.34819 20.2205 5.2018C20.9457 6.05919 21 7.37246 21 9.27803V12.722C21 14.9057 20.6537 16.1669 19.8422 16.9394C19.0508 17.6927 17.8276 18 15.6201 18H6.37974C1.832 18 1 16.2226 1 12.722V9.27803C1 7.47109 1 6.16553 1.70123 5.27945C2.42045 4.37065 3.77594 4 6.37974 4H15.6201ZM9.64406 13.6568L13.8401 11.4755C14.0532 11.3647 14.1867 11.1452 14.1865 10.9059C14.1861 10.6667 14.0521 10.4475 13.8386 10.3372L9.64258 8.17004C9.44265 8.06673 9.20297 8.07469 9.01026 8.19109C8.81761 8.3075 8.70006 8.51541 8.70006 8.7395V13.088C8.70006 13.3125 8.81794 13.5206 9.01097 13.6369C9.11348 13.6987 9.22923 13.7297 9.34523 13.7297C9.44768 13.7297 9.55026 13.7055 9.64406 13.6568Z"
      className="socialIcons-SVG"
    />
  </svg>
);

export { FacebookSVG, TwitterSVG, LinkedinSVG, YoutubeSVG };
